import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
/**
 * Reusable in-app screen header with back chevron + title.
 */
export function ScreenHeader({
  title,
  subtitle,
  onBack
}: {
  title: string;
  subtitle?: string;
  onBack?: () => void;
}) {
  return <header className="flex items-start gap-3 px-5 pt-2 pb-4" style={{
    backgroundColor: '#F8F9FA'
  }} data-id="element-560">
      <button type="button" onClick={onBack} aria-label="Go back" className="shrink-0 flex items-center justify-center rounded-full bg-white transition-colors active:bg-neutral-100" style={{
      width: 44,
      height: 44,
      border: '1px solid #C0C0C0'
    }} data-id="element-561">
        <ArrowLeftIcon size={20} style={{
        color: '#1A1A1A'
      }} data-id="element-562" />
      </button>
      <div className="flex-1 min-w-0 pt-1" data-id="element-563">
        <h1 className="tracking-tight" style={{
        fontSize: 22,
        fontWeight: 700,
        color: '#1A1A1A',
        lineHeight: 1.25
      }} data-id="element-564">
          {title}
        </h1>
        {subtitle && <p className="mt-1" style={{
        fontSize: 13,
        color: '#525252',
        lineHeight: 1.55
      }} data-id="element-565">
            {subtitle}
          </p>}
      </div>
    </header>;
}